import { Transaction } from "@finway-group/shared/lib/models"
import moment from "moment-timezone"

import { TransactionService } from "Shared/services"
import store from "Shared/store"
import { refetchTable } from "Shared/store/actions/tables/tableActions"
import { TablesEnum } from "Shared/store/reducers/tableConfigReducer"
import { isNotSet } from "Shared/utils/helpers"

export const archiveTransactions = async (transactionIds: Array<string>, table: TablesEnum) => {
    await TransactionService.archiveTransactions(transactionIds)
    store.dispatch(refetchTable(table))
    store.dispatch(refetchTable(TablesEnum.TRANSACTIONS_ARCHIVE))
}

export const unarchiveTransactions = async (transactionIds: Array<string>) => {
    await TransactionService.unarchiveTransactions(transactionIds)

    store.dispatch(refetchTable(TablesEnum.TRANSACTIONS_INFLOW))
    store.dispatch(refetchTable(TablesEnum.TRANSACTIONS_OUTFLOW))
    store.dispatch(refetchTable(TablesEnum.TRANSACTIONS_ALL))
    store.dispatch(refetchTable(TablesEnum.TRANSACTIONS_ARCHIVE))
}

export const isTransactionArchived = (transaction: Transaction, archiveAfterXDays: number) =>
    !isNotSet(transaction.isManuallyArchived)
        ? transaction.isManuallyArchived
        : moment(transaction.transactionData.date).isSameOrBefore(moment().subtract(archiveAfterXDays, "days").toDate())

export const isTransactionManuallyUnarchived = (transaction: Transaction, archiveAfterXDays: number) =>
    !isNotSet(transaction.isManuallyArchived) &&
    !transaction.isManuallyArchived &&
    moment(transaction.transactionData.date).isSameOrBefore(moment().subtract(archiveAfterXDays, "days").toDate())
